const getCurrentHash = state => state?.router?.location?.hash;

export default getCurrentHash;
